import { createRoute } from '@tanstack/react-router'

import OrderYarcheRedirectPage from '../pages/OrderYarcheRedirectPage'
import { orderRoute } from './OrderRoute'

export const orderYarcheGuestRedirectCreateRoute = createRoute({
  getParentRoute: () => orderRoute,
  component: () => <OrderYarcheRedirectPage />,
  path: '/yarche-guest'
})
